import React,{useState, useEffect} from 'react'
import HeaderCard from "../../common/header-author/Header-Card";
import CardLatest from "../../cards/CardLatest";
import {get, postJson} from "sodon-http/API";
import {API_URL} from "../../../constans/API_URL";
import {useQuery} from "@tanstack/react-query";
export default function Latest() {



    const { data: latestData } = useQuery({
        queryKey: ['Latest',],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/episode/latest?size=8`);
        },
    });


    const data = latestData?.payload;



    return (
        <div className={"container"}>
            <HeaderCard title={"Шинээр нэмэгдсэн"} link={"latest-episodes"} />
            <div className={"mt-5 grid lg:gap-4  sm:gap-3 max-sm:gap-2  lg:grid-cols-4  sm:grid-cols-3 max-sm:grid-cols-2"}>
                {
                    data && data.map((item, index) => (
                        <CardLatest key={index} item={item} />
                    ))
                }
            </div>
        </div>
    )
}
